import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=4a2f582c&scoped=true&"
import script from "./FirstPage.vue?vue&type=script&lang=js&"
export * from "./FirstPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f582c",
  null
  
)

export default component.exports